<template>
    <div class="cp rate">
        <div class="bar">
            <!-- <div class="tag" v-for="(range, key) in item.range" :key="key" :style="{
                left: range.width +'%',
            }">
                <span class="test">{{ $okaTool.numberToStringFormat(range.qty) }}</span>
            </div>
            <div class="processes" :style="{
                width: item.range[item.current].width +'%',
            }"></div> -->
            <div
                class="tag"
                v-for="(item, index) in range"
                :key="item.qty"
                :style="{
                    left: index * width +'%',
                }"
            >
                <span class="test">{{ item.qty }}</span>
            </div>
            <div
                class="current"
                :style="{
                    width: current * width +'%',
                }"
            ></div>
        </div>
        <input
            type="range"
            min="0"
            :max="max"
            v-model="model"
            step="1"
        >
    </div>
</template>

<script>
    export default {
        props: {
            range: {
                type: Array,
                require: false,
                default: () => {
                    return []
                },
            },
            current: {
                type: Number,
                require: false,
                default: 0,
            },
            value: {
                type: [String, Number],
                require: false,
                default: '0',
            },
        },
        computed: {
            max: function(){
                let $range = this.range;
                
                if( $range.length ) {
                    return $range.length - 1;
                }else {
                    return 1;
                }
            },
            width: function(){
                return 100 / this.max;
            },
            model: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                },
            },
        },
    }
</script>

<style scoped lang="scss">
    
    .rate {
        $dote_size: 16px;
        $bar_size: 8px;
        
        position: relative;
        margin: $interval-m $interval-m $interval-xxl;
        line-height: 0;

        @include media('mobile') {
            margin-bottom: $interval-m;
        }

        $danger: map-get($colors, 'danger');
        $danger_text: map-get($danger, 'text');
        $danger_border: map-get($danger, 'border');

        .bar {
            position: absolute;
            top: 0;
            right: $dote_size / 2;
            left: $dote_size / 2;
            height: $bar_size;
            background: $light-gray;
            line-height: 1;

            .current {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                background-color: $danger_text;
                transition: 0.2s linear;

                &::after {
                    content: $content;
                    position: absolute;
                    top: $bar_size / -2;
                    right: $dote_size / -2;
                    width: $dote_size;
                    height: $dote_size;
                    background-color: $danger_text;
                    border-radius: $dote_size;
                    box-shadow: 0 0 0 $interval-s $danger_border;
                    z-index: 1;
                    pointer-events: none;
                }
            }

            .tag {
                position: absolute;
                top: 0;
                bottom: 0;
                width: $bar_size;
                margin-left: $bar_size * -0.5;
                background-color: $deep;
                border-radius: 50%;
            
                .test {
                    $text_w: 60px;

                    position: absolute;
                    top: $bar_size + $interval-l;
                    width: $text_w;
                    left: $text_w / -2 + $bar_size / 2;
                    text-align: center;
                    font-size: $font-size-xs;

                    @include media('mobile') {
                        display: none;
                    }
                }
            }
        }

        input[type="range"] {
            position: relative;
            width: 100%;
            -webkit-appearance: none;
            appearance: none;
            background-color: transparent;
            cursor: pointer;

            &::-webkit-slider-thumb {
                -webkit-appearance: none; /* Override default look */
                appearance: none;
                background-color: $deep;
                width: $dote_size;
                height: $dote_size;
                margin-top: ($dote_size - $bar_size) / -2;
                border-radius: 100px;
                box-shadow: 0 0 0 $interval-s $light-gray;
            }

            &::-webkit-slider-runnable-track {
                height: $bar_size;
            }

            &::-moz-range-track {
                
            }

            &::-moz-range-thumb {
                -webkit-appearance: none; /* Override default look */
                appearance: none;
                background-color: $deep;
                width: $dote_size;
                height: 4px;
                border: 0;
            }
        }

        // input[type="range"] {
        //     -webkit-appearance: none;
        //     width: 100%;
        //     outline: none;      //避免點選會有藍線或虛線
        //     background: none;
        //     position: relative;
        //     z-index: 1;
        //     height: $bar_size;

        //     &::-webkit-slider-thumb {
        //         opacity: 0;
        //     }
            
        //     &::-webkit-slider-runnable-track {
        //         width: 100%;
        //         height: $interval-xs;
        //         background-color: transparent;
        //         border-radius: $interval-s;
        //     }

        //     &::-moz-range-thumb {
        //         top: $dote_size * -0.5; //margin-top = (track height in pixels / 2) - (thumb height in pixels /2)
        //         width: $dote_size;
        //         height: $dote_size;
        //         background-color: $major-color;
        //         border-radius: 50%;
        //         transition: .2s; //點選放大時候的漸變時間
        //         border: 0;
        //     }
            
        //     &::-moz-range-track {
        //         width: 100%;
        //         height: $interval-xs;
        //         background-color: transparent;
        //         border-radius: $interval-s;
        //     }
        // }
    }
</style>
